import React, { useState } from "react";
import { CardLibrary } from "../../../components/CardLibrary/CardLibrary";
import { FormButton } from "../../../components/FormButton/FormButton";
import { download } from "../../../utils/download";
import { DeliverablesWrapper, Row, Title } from "../style";

const deliverableStep = 40;

export const Deliverables = ({ deliverables }) => {
  const [deliverablesLength, setDeliverablesLength] = useState(
    deliverableStep - 1,
  );
  // const displayedDeliverables = deliverables.filter(
  //   (_, i) => i <= deliverablesLength
  // );
  return (
    <>
      <Title style={{ marginTop: "30px" }}>Understand Energy Communities</Title>
      <DeliverablesWrapper>
        {deliverables
          .filter(({ title = "" }) => title.includes("2.2"))
          .map(
            ({ image: { url: img }, title, files: { filename, url } }, key) => (
              <CardLibrary
                {...{
                  withContent: true,
                  content: title,
                  img,
                  title: "",
                  key,
                  onButtonClick: () => download(url, filename),
                }}
              />
            ),
          )}
      </DeliverablesWrapper>
      <Title style={{ marginTop: "30px" }}>Tools and platforms</Title>
      <DeliverablesWrapper>
        {deliverables
          .filter(
            ({ title = "" }) =>
              title.includes("2.3") ||
              title.includes("2.4") ||
              title.includes("4.1") ||
              title.includes("4.2") ||
              title.includes("7.2") ||
              title.includes("7.4"),
          )
          .map(
            ({ image: { url: img }, title, files: { filename, url } }, key) => (
              <CardLibrary
                {...{
                  withContent: true,
                  content: title,
                  img,
                  title: "",
                  key,
                  onButtonClick: () => download(url, filename),
                }}
              />
            ),
          )}
      </DeliverablesWrapper>
      <Title style={{ marginTop: "30px" }}>Methods and implementation</Title>
      <DeliverablesWrapper>
        {deliverables
          .filter(
            ({ title = "" }) =>
              title.includes("3.1") ||
              title.includes("3.2") ||
              title.includes("4.4") ||
              title.includes("6.1") ||
              title.includes("6.2"),
          )
          .map(
            ({ image: { url: img }, title, files: { filename, url } }, key) => (
              <CardLibrary
                {...{
                  withContent: true,
                  content: title,
                  img,
                  title: "",
                  key,
                  onButtonClick: () => download(url, filename),
                }}
              />
            ),
          )}
      </DeliverablesWrapper>
      <Title style={{ marginTop: "30px" }}>Results and evaluation</Title>
      <DeliverablesWrapper>
        {deliverables
          .filter(
            ({ title = "" }) =>
              title.includes("4.3") ||
              title.includes("5.1") ||
              title.includes("5.2") ||
              title.includes("5.3") ||
              title.includes("5.4"),
          )
          .map(
            ({ image: { url: img }, title, files: { filename, url } }, key) => (
              <CardLibrary
                {...{
                  withContent: true,
                  content: title,
                  img,
                  title: "",
                  key,
                  onButtonClick: () => download(url, filename),
                }}
              />
            ),
          )}
      </DeliverablesWrapper>
      <Title style={{ marginTop: "30px" }}>Policy and impact </Title>
      <DeliverablesWrapper>
        {deliverables
          .filter(
            ({ title = "" }) => title.includes("6.3") || title.includes("7.6"),
          )
          .map(
            ({ image: { url: img }, title, files: { filename, url } }, key) => (
              <CardLibrary
                {...{
                  withContent: true,
                  content: title,
                  img,
                  title: "",
                  key,
                  onButtonClick: () => download(url, filename),
                }}
              />
            ),
          )}
      </DeliverablesWrapper>
      {/* {deliverablesLength < displayedDeliverables.length && (
        <Row style={{ justifyContent: "center", marginTop: "5%" }}>
          <FormButton
            {...{
              style: { color: "black" },
              name: "SHOW MORE",
              value: "SHOW MORE",
              onHoverStyle: {
                backgroundColor: "var(--comanage-green-1)",
                borderColor: "var(--comanage-green-1)",
              },
              onClick: () =>
                setDeliverablesLength(deliverablesLength + deliverableStep),
            }}
          />
        </Row>
      )} */}
    </>
  );
};

// Understand Energy Communities
// will include
// 2.2

// Tools and platforms
// will include
// 2.3
// 2.4
// 4.1
// 4.2
// 7.2
// 7.4

// Methods and implementation
// will include
// 3.1
// 3.2
// 4.4
// 6.1
// 6.2

// Results and evaluation
// will include
// 4.3
// 5.1
// 5.2
// 5.3
// 5.4

// Policy and impact
// will include
// 6.3
// 7.6
